"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@account-bulk/success",
  ERROR: "@@account-bulk/error",
  RESET: "@@account-bulk/reset",
  ENABLE: "@@account-bulk/bulk-enable",
  DISABLE: "@@account-bulk/bulk-disable",
  SOFT_DELETE: "@@account-bulk/bulk-soft-deletet",
  RESTORE: "@@account-bulk/bulk-restore-soft-deletet",
  HARD_DELETE: "@@account-bulk/bulk-hard-delete",
  CLEAN: "@@account-bulk/bulk-clean"
};
exports.actionTypes = actionTypes;